<template>
  <div>
    <!-- Render a dialog for each item in the dialog stack -->
    <template v-for="(dialog, index) in dialogStack">
      <v-dialog
        :key="index"
        :value="dialog.show"
        max-width="800px"
        persistent
        @input="updateDialogShow(index, $event)"
      >
        <v-card>
          <base-form
            ref="baseForm"
            :schema="dialog.schemas"
            :is-dialog="true"
            :show="dialog.show"
            :loading="dialog.loading"
            :editing-object="dialog.oldObject"
            @submit="(formData) => handleSubmit(formData, index)"
            @close="() => closeDialog(index)"
          >
            {{ dialog.title }}
            <template #subtitle>
              {{ dialog.subtitle }}
            </template>
          </base-form>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { useBaseFormDialogStore } from '@/model/baseForm/baseFormDialogStore'
import { mapState } from 'pinia'

export default {
  name: 'BaseFormDialog',
  components: {
    BaseForm
  },
  computed: {
    ...mapState(useBaseFormDialogStore, [
      'dialogStack'
    ])
  },
  methods: {
    updateDialogShow (index, value) {
      // If dialog is being closed by clicking outside, handle it properly
      if (!value) {
        this.closeDialog(index)
      }
    },
    closeDialog (index) {
      const store = useBaseFormDialogStore()

      // If closing the current dialog (top of stack)
      if (index === this.dialogStack.length - 1) {
        store.closeCurrentDialog(null)
      } else {
        // For dialogs not at the top, we need to handle them differently
        // This is a more complex case that might require custom logic
        console.warn('Attempting to close a dialog that is not at the top of the stack')
      }
    },
    handleSubmit (formData, index) {
      const store = useBaseFormDialogStore()

      // If submitting the current dialog (top of stack)
      if (index === this.dialogStack.length - 1) {
        store.closeCurrentDialog(formData)
      } else {
        // For dialogs not at the top, we need to handle them differently
        console.warn('Attempting to submit a dialog that is not at the top of the stack')
      }
    }
  }
}
</script>
